import { User } from 'module/api/user/types';
import { fullName } from 'module/helpers/full-name';

export const byFullName = (
  a: Pick<User, 'firstName' | 'lastName'>,
  b: Pick<User, 'firstName' | 'lastName'>,
) => {
  const a_full_name = (fullName(a) ?? '').toLowerCase();
  const b_full_name = (fullName(b) ?? '').toLowerCase();

  return a_full_name === b_full_name ? 0 : a_full_name > b_full_name ? 1 : -1;
};
